exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.user-chips.v-input .v-input__control{margin-top:-9px\n}\n.user-chips.v-input .v-chip{height:20px;margin-left:0;margin-right:8px;padding:0 12px\n}\n.user-chips.v-input .v-chip .v-avatar{height:26px!important;min-width:26px!important;width:26px!important\n}\n.user-chips.v-input .v-chip span{padding:0\n}", ""]);

// exports
